import React from 'react'
import Manager from '../../public/components/Manager'
import AssetAccDiv from './AssetAccDiv'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        申请中: {
            buttons: [
                { text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <AssetAccDiv {...props} id={0} onSave={refreshPage}/>) },
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 150, search: true, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AssetAccDiv {...props} id={data.id} onSave={refreshPage} />)
            }
        },
        退回申请: {
            buttons: [
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 150, search: true, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AssetAccDiv {...props} id={data.id} onSave={refreshPage} />)
            }
        },
        签核中: {
            buttons: [
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 150, search: true, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AssetAccDiv {...props} id={data.id} onSave={refreshPage} readOnly={true} />)
            }
        },
        已完成: {
            buttons: [
            ],
            columns: [
                { _text: '申请编号', field: 'Number', minWidth: 150, search: true, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
                { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <AssetAccDiv {...props} id={data.id} onSave={refreshPage} />)
            }
        },
    }
}

export default props => <Manager {...props} config={config} />